module.exports = __webpack_public_path__ + "338160d605424f078b4faa4116d0190a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Light.ttf
// module id = 1241
// module chunks = 0